<div class="flex items-end">
  <div *ngIf="member">
    <img *ngIf="member.image; else noImageTemplate" [src]="member.image" alt="{{ member.name }}"
      class="rounded-full border-1 border-white z-10 {{ config.size }}" />
    <ng-template #noImageTemplate>
      <div [style.background-color]="member.bgColor || defaultColor" [ngClass]="[
          'rounded-full',
          'flex',
          'justify-center',
          'items-center',
          'border-2',
          'border-white',
          'text-white',
          'text-md',
          config.size ?? 'w-8 h-8'
        ]">
        {{ initials }}
      </div>
    </ng-template>
  </div>
</div>
